
import IconBtn from "@/components/molecules/IconBtn.vue";
import TableInline from "@/components/atoms/TableInline.vue";
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import {defineComponent, PropType} from "vue";
import TableUtil from "@/components/pages/contract/TradeContractList/TableUtil";
import Formatter from "@/utils/Formatter";
import TradeContractFormatView, {
  createTradeContractFormatView, emptyTradeContractFormatView
} from "@/components/pages/contract/TradeContractFormat/TradeContractFormatView";
import IoablePageMixin from "@/router/IoablePageMixin";
import {TradeContractFormatGroup} from "@/store/modules/hcs/tradeContractFormatGroup/model";
import {TradeContractFormat} from "@/store/modules/hcs/tradeContractFormat/model";
import {mapActions, mapGetters, mapMutations} from "vuex";
import {AxiosInstance} from "axios";
import FormatTable from "@/components/pages/contract/TradeContractFormat/FormatTable.vue";
import SimpleDialog from "@/components/organisms/SimpleDialog.vue";
import SelectFormatForm from "@/components/pages/contract/TradeContractFormatGroup/SelectFormatForm.vue";
import BetterSet from "betterset";
import DraggableElTable from "@/components/atoms/DraggableElTable.vue";
import TradeContractViewPanel from "@/components/pages/contract/TradeContract/TradeContractViewPanel.vue";

export default defineComponent({
  name: 'SelectedFormatTab',
  components: {
    TradeContractViewPanel,
    DraggableElTable,
    SelectFormatForm,
    SimpleDialog,
    FormatTable,
    IconBtn, TableInline, TabItemTemplate, TextFieldLike
  },
  mixins: [
    IoablePageMixin,
    TableUtil,
    Formatter,
  ],
  emits: [
    'dirty'
  ],
  inject: ['tabItemBounds'],
  props: {
    group: {
      type: Object as PropType<TradeContractFormatGroup>,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    hideToolbar: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      formats: [] as TradeContractFormat[],
      selectDialog: {
        visible: false,
        formats: [] as TradeContractFormat[],
      },
      viewDialog: {
        visible: false,
        format: emptyTradeContractFormatView(),
      }
    };
  },
  computed: {
    ...mapGetters({
      account: 'hcs/account',
      _hcsClient: 'hcs/client',
    }),
    hcsClient(): AxiosInstance {
      return this._hcsClient as AxiosInstance;
    },
    formatsView(): TradeContractFormatView[] {
      return this.formats.map(s => createTradeContractFormatView(s, this.$store));
    },
  },
  methods: {
    ...mapActions({
      fetchTradeContractFormatGroups: "hcs/tradeContractFormatGroup/findList",
      fetchTradeContractFormatGroup: "hcs/tradeContractFormatGroup/get",
    }),
    ...mapMutations({
      showSnackbar: 'showSnackbar',
    }),
    async load() {
      const {data: formats} = await this.hcsClient.get<TradeContractFormat[]>(`/trade_contract_format_groups/${this.group.id}/formats`);
      this.formats = formats;
    },
    async save() {
      await this.hcsClient.post(`/trade_contract_format_groups/${this.group.id}/formats`, {
        formatIds: this.formats.map(f => f.id)
      });
    },
    openSelectDialog() {
      this.selectDialog.visible = true;
      this.selectDialog.formats = this.formats.slice();
    },
    closeSelectDialog(apply: boolean) {
      if (apply) {
        const current = new BetterSet(this.formats.map(f => f.id));
        const next = new BetterSet(this.selectDialog.formats.map(f => f.id));

        // 削除
        for(const willDeleteId of current.complement(next)) {
          const index = this.formats.findIndex(f => f.id === willDeleteId);
          if(index !== -1) {
            this.formats.splice(index, 1);
            this.$emit('dirty');
          }
        }

        // 追加
        for(const willAddId of next.complement(current)) {
          const willAdd = this.selectDialog.formats.find(f => f.id === willAddId);
          if(willAdd) {
            this.formats.push(willAdd);
            this.$emit('dirty');
          }
        }
      }
      this.selectDialog.visible = false;
    },
    handleDeleteButtonClick(row: TradeContractFormatView) {
      const index = this.formats.findIndex(f => f.id === row.id);
      if(index !== -1) {
        this.formats.splice(index, 1);
        this.$emit('dirty');
      }
    },
    handleViewButtonClick(row: TradeContractFormatView) {
      this.viewDialog.format = row;
      this.viewDialog.visible = true;
    },
    handleDragEnd(e: any) {
      const oldIdx: number = e.oldDraggableIndex;
      const newIdx: number = e.newDraggableIndex;
      const [element] = this.formats.splice(oldIdx, 1);
      this.formats.splice(newIdx, 0, element);
      this.$emit('dirty');
    },
  }

});
